/*
 * nv-tracking.js – North Outdoor / Northview -teemamittaus v2
 * Sijoitus: teeman assets/nv-tracking.js, ladataan theme.liquidista (ks. ohje).
 *
 * Neljä osaa:
 *   A) nv_page            – sivukonteksti + suostumustila, joka sivulatauksella, EI tunnisteita
 *   B) nv_consent_decision – bannerin päätös (hyväksy/hylkää), EI tunnisteita
 *   C) nv_scroll_depth    – 25/50/75/100 %, kerran per sivulataus, EI tunnisteita
 *   D) attribuutio        – klikkitunnisteet + kävijätunniste koriin → note_attributes
 *                           VAIN analytiikka- JA markkinointisuostumuksella
 *
 * Kaikki tapahtumat julkaistaan Shopify.analytics.publish-kutsulla ja pikseli kuuntelee ne.
 * Ilman suostumusta selaimeen ei kirjoiteta mitään (ei cookie, ei localStorage, ei sessionStorage).
 * Kaikki vikaantuu hiljaa: try/catch ja .catch() joka kohdassa.
 */
(function () {
  'use strict';
  if (window.__nvTrackingLoaded) return;
  window.__nvTrackingLoaded = true;

  // ---------- Asetukset ----------
  var CFG = window.nvConfig || {};
  var ROOT = CFG.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (ROOT.charAt(ROOT.length - 1) !== '/') ROOT += '/';

  var CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid'];
  var UTM_KEYS   = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var ALL_KEYS   = CLICK_KEYS.concat(UTM_KEYS);
  var ATTR_PREFIX = 'nv_';          // koriattribuuttien etuliite, ei törmää muiden sovellusten avaimiin
  var SS_KEY  = 'nv_attr';          // sessionStorage (vain suostumuksella)
  var LS_VID  = 'nv_vid';           // localStorage (vain suostumuksella)
  var MAX_LEN = 200;

  // ---------- Apurit ----------
  function safe(fn) { try { return fn(); } catch (e) { return undefined; } }

  function cookie(name) {
    return safe(function () {
      var m = document.cookie.match('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)');
      return m ? decodeURIComponent(m[1]) : null;
    }) || null;
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var d = Date.now();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0; d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  // Julkaisu pikselille. Jos Shopify.analytics ei ole vielä valmis, jonotetaan max 10 s.
  var queue = [];
  function publishReady() {
    return !!(window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function');
  }
  function pub(name, data) {
    if (publishReady()) { safe(function () { window.Shopify.analytics.publish(name, data); }); }
    else queue.push([name, data]);
  }
  (function drain(tries) {
    if (publishReady()) { while (queue.length) { var q = queue.shift(); pub(q[0], q[1]); } return; }
    if (tries > 0) setTimeout(function () { drain(tries - 1); }, 250);
  })(40);

  // ---------- Suostumus ----------
  // Shopify Customer Privacy API. Ladataan tarvittaessa.
  function cp() { return window.Shopify && window.Shopify.customerPrivacy; }

  function consentState() {
    var api = cp();
    if (!api) return { available: false, analytics: null, marketing: null, decided: null };
    return safe(function () {
      return {
        available: true,
        analytics: !!api.analyticsProcessingAllowed(),
        marketing: !!api.marketingAllowed(),
        preferences: !!api.preferencesProcessingAllowed(),
        sale_of_data: !!api.saleOfDataAllowed(),
        decided: !api.shouldShowBanner()   // false = banneri näkyy vielä, päätöstä ei ole
      };
    }) || { available: true, analytics: null, marketing: null, decided: null };
  }

  function tracked() { var s = consentState(); return s.analytics === true && s.marketing === true; }

  function withConsentApi(cb) {
    if (cp()) return cb();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      safe(function () {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { cb(); });
      });
    } else cb();
  }

  // ---------- Konteksti (nv_page) ----------
  function context() {
    var s = consentState();
    return {
      market:    CFG.market   || (window.Shopify && window.Shopify.country) || null,
      locale:    CFG.locale   || (window.Shopify && window.Shopify.locale)  || null,
      currency:  CFG.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || null,
      page_type: CFG.pageType || null,
      template:  CFG.template || null,
      path:      location.pathname,
      referrer_host: safe(function () { return document.referrer ? new URL(document.referrer).hostname : null; }) || null,
      utm_source:   param('utm_source'),
      utm_medium:   param('utm_medium'),
      utm_campaign: param('utm_campaign'),
      viewport_w: window.innerWidth,
      viewport_h: window.innerHeight,
      consent_available: s.available,
      consent_analytics: s.analytics,
      consent_marketing: s.marketing,
      consent_decided:   s.decided,
      vid: tracked() ? visitorId() : null      // oma kävijätunniste vain suostumuksella
    };
  }

  var _params = null;
  function param(k) {
    if (!_params) _params = safe(function () { return new URLSearchParams(location.search); }) || new URLSearchParams();
    var v = _params.get(k);
    return v ? String(v).slice(0, MAX_LEN) : null;
  }

  // ---------- Kävijätunniste (vain suostumuksella) ----------
  function visitorId() {
    if (!tracked()) return null;
    return safe(function () {
      var v = localStorage.getItem(LS_VID);
      if (!v) { v = uuid(); localStorage.setItem(LS_VID, v); }
      return v;
    }) || null;
  }

  // ---------- Vierityssyvyys (nv_scroll_depth) ----------
  var MARKS = [25, 50, 75, 100];
  var sent = {};
  function pageHeight() {
    var b = document.body, e = document.documentElement;
    return Math.max(b.scrollHeight, b.offsetHeight, e.clientHeight, e.scrollHeight, e.offsetHeight);
  }
  function checkScroll() {
    var h = pageHeight(); if (!h) return;
    var vh = window.innerHeight;
    var pct = Math.min(100, Math.round((window.scrollY + vh) / h * 100));
    var shortPage = h < vh * 1.5;
    for (var i = 0; i < MARKS.length; i++) {
      var m = MARKS[i];
      if (pct >= m && !sent[m]) {
        sent[m] = true;
        pub('nv_scroll_depth', {
          percent: m, page_height: h, viewport_height: vh, short_page: shortPage,
          path: location.pathname, page_type: CFG.pageType || null, market: CFG.market || null
        });
      }
    }
  }
  var throttle = null;
  window.addEventListener('scroll', function () {
    if (throttle) return;
    throttle = setTimeout(function () { throttle = null; checkScroll(); }, 250);
  }, { passive: true });
  // HUOM: ei resize-nollausta. Mobiilin osoitepalkki laukaisee resize-tapahtumia ja tuplaisi lähetykset.

  // ---------- Attribuutio (vain suostumuksella) ----------
  var memLanding = { at: new Date().toISOString(), page: location.pathname.slice(0, MAX_LEN) };

  function collectFromUrl() {
    var found = {};
    ALL_KEYS.forEach(function (k) { var v = param(k); if (v) found[k] = v; });
    return found;
  }

  function readStored() { return safe(function () { return JSON.parse(sessionStorage.getItem(SS_KEY) || 'null'); }) || null; }
  function writeStored(o) { safe(function () { sessionStorage.setItem(SS_KEY, JSON.stringify(o)); }); }

  // Yhdistää: uusi klikki URL:ssa korvaa KAIKKI klikki- ja utm-avaimet (ei sekoitu vanhaan),
  // laskeutumistiedot säilyvät istunnon ensimmäisestä sivusta.
  function currentAttr() {
    var stored = tracked() ? readStored() : null;
    var fresh = collectFromUrl();
    var hasFreshClick = Object.keys(fresh).length > 0;
    var out = {};
    if (stored && !hasFreshClick) {
      out = stored;
    } else {
      ALL_KEYS.forEach(function (k) { out[k] = fresh[k] || ''; });
      out.landing_at   = (stored && stored.landing_at)   || memLanding.at;
      out.landing_page = (stored && stored.landing_page) || memLanding.page;
      if (!stored && !hasFreshClick) {
        // suora/orgaaninen laskeutuminen ilman parametreja: tallennetaan silti laskeutumissivu
        out.landing_referrer = safe(function () { return document.referrer ? new URL(document.referrer).hostname : ''; }) || '';
      }
      if (tracked()) writeStored(out);
    }
    return out;
  }

  function attrPayload() {
    var a = currentAttr();
    var p = {};
    Object.keys(a).forEach(function (k) { p[ATTR_PREFIX + k] = String(a[k] || '').slice(0, MAX_LEN); });
    p[ATTR_PREFIX + 'visitor'] = cookie('_shopify_y') || '';      // = pikselin clientId
    p[ATTR_PREFIX + 'vid']     = visitorId() || '';
    p[ATTR_PREFIX + 'customer_id'] = CFG.customerId ? String(CFG.customerId) : '';
    p[ATTR_PREFIX + 'market']  = CFG.market || '';
    return p;
  }

  var lastWritten = null;
  function writeToCart(requireItems) {
    if (!tracked()) return;
    var payload = attrPayload();
    var sig = JSON.stringify(payload);
    if (sig === lastWritten) return;                // ei turhia kirjoituksia
    lastWritten = sig;

    function doWrite() {
      return fetch(ROOT + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: payload })
      }).catch(function () { lastWritten = null; });
    }
    if (!requireItems) return doWrite();
    // Korisivulla varmistetaan ettei tyhjää koria luoda turhaan
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.item_count > 0) return doWrite(); else lastWritten = null; })
      .catch(function () { lastWritten = null; });
  }

  // Koriinlisäyksen havaitseminen: fetch-kääre (kattaa Dawn-pohjaiset teemat, quick add, upsellit)
  (function wrapFetch() {
    var orig = window.fetch;
    if (typeof orig !== 'function') return;
    window.fetch = function (input, init) {
      var url = safe(function () { return typeof input === 'string' ? input : (input && input.url) || ''; }) || '';
      var p = orig.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) { if (res && res.ok) setTimeout(function () { writeToCart(false); }, 0); }).catch(function () {});
      }
      return p;
    };
  })();
  // XHR-kääre vanhempia teemoja varten
  (function wrapXhr() {
    var open = XMLHttpRequest.prototype.open;
    if (!open) return;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (/\/cart\/add(\.js)?(\?|$)/.test(String(url))) {
          this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) writeToCart(false); });
        }
      } catch (e) {}
      return open.apply(this, arguments);
    };
  })();
  // Varmistus: tavallinen lomakelähetys ilman JS-koria
  document.addEventListener('submit', function (e) {
    var f = e.target; var action = f && f.getAttribute && f.getAttribute('action');
    if (action && action.indexOf('/cart/add') > -1) setTimeout(function () { writeToCart(false); }, 1500);
  }, true);

  // ---------- Suostumuksen muutos ----------
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = (e && e.detail) || {};
    var s = consentState();
    pub('nv_consent_decision', {
      analytics: typeof d.analyticsAllowed === 'boolean' ? d.analyticsAllowed : s.analytics,
      marketing: typeof d.marketingAllowed === 'boolean' ? d.marketingAllowed : s.marketing,
      market: CFG.market || null, locale: CFG.locale || null, path: location.pathname
    });
    if (tracked()) {
      // Suostumus tuli laskeutumisen jälkeen: muistissa olleet parametrit talteen nyt
      currentAttr();
      if (location.pathname.indexOf(ROOT + 'cart') === 0) writeToCart(true);
    } else {
      // Suostumus peruttu tai evätty: siivotaan omat tallenteet
      safe(function () { sessionStorage.removeItem(SS_KEY); localStorage.removeItem(LS_VID); });
    }
  });

  // ---------- Käynnistys ----------
  function start() {
    withConsentApi(function () {
      pub('nv_page', context());
      if (tracked()) {
        currentAttr();                                   // parametrit talteen (sessionStorage)
        if (location.pathname.indexOf(ROOT + 'cart') === 0) writeToCart(true);
      }
      // Ilman suostumusta URL-parametrit pysyvät vain muistissa (_params) tämän sivun ajan.
      checkScroll();
    });
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start);
})();
